import { Pagination, PaginationItem, Typography } from '@mui/material';
import React, { useState } from 'react';
import { CollapsibleTable } from "../../components/CollapsibleTable";
import { MainContainer } from "../../components/MainContainerComp";
import ScrollIndicatorsComp from '../../components/ScrollIndicatorsComp/ScrollIndicatorsComp';
import { useSameWidthAsPreviousElement } from '../../utils/hooks/useSameWidthAsPreviousElement';
import { IUsageResultsData } from './UsageResultsData';
import { paginationStyles, subHeaderStyles } from "./styled";
const cols = ['Date', 'Activity', 'Description'];

interface UsageResultsProps {
  data: IUsageResultsData,
  startDate: string,
  endDate: string,
}

export const UsageResults = ({ data, startDate, endDate }: UsageResultsProps) => {
  const [page, setPage] = useState<number>(1);
  const rowsPerPage = 10;
  const startIndex = (page - 1) * rowsPerPage;
  const endIndex = startIndex + rowsPerPage;
  const rows = data.logEvents;
  const pageRows = rows.slice(startIndex, endIndex);
  const totalPages = Math.ceil(rows.length / rowsPerPage);
  const [elementRef] = useSameWidthAsPreviousElement();

  const onPageChange = (event: React.ChangeEvent<unknown>, page: number) =>
    setPage(page);

  return (
    <MainContainer>
      <Typography data-automation="date-range" sx={subHeaderStyles}>
        Start Date: {startDate} - End Date: {endDate}
      </Typography>
      <Typography 
        component={'div'} 
        variant='container' 
        data-automation="data-container"
      >
        <ScrollIndicatorsComp>
          <CollapsibleTable
            cols={cols.map(title => ({ title }))}
            rows={pageRows}
            isOneLevel={true}
            dataAutomation={{
              noRecords: 'no-records-text',
              columns: [],
            }}
          />
          {totalPages > 1 && <Pagination
            ref={elementRef}
            sx={paginationStyles}
            onChange={onPageChange}
            color="primary"
            count={totalPages}
            variant="outlined"
            shape="rounded"
            renderItem={(item) => (
              <PaginationItem
                {...item}
                data-automation={(item.type === 'previous' && 'prev-btn') || (item.type === 'next' && 'next-btn') || 'page'}
              />
            )
            }
          />}
        </ScrollIndicatorsComp>
      </Typography>
    </MainContainer>
  )
}